import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue'
import AudioTextHighlight from '@/components/AudioTextHighlight/index.vue'
import { getASRDetail } from '@/api/asr'
import { ParagraphItem } from '@/components/AudioTextHighlight/type'
import { getAudioByResultPath } from '@/api/asr'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  fileId: {
    type: String,
    required: true
  }
},
  setup(__props) {

const props = __props


const contentList = ref<ParagraphItem[]>([])
const taskTitle = ref<string>('')
const audioSrc = ref('')
const loading = ref(false)
async function getContentDetail() {
  const id = props.fileId
  loading.value = true
  try {
    const res = await getASRDetail(id)
    const {
      paragraphList,
      name,
      audioPath
    } = res.data
    contentList.value = paragraphList || []
    taskTitle.value = name
    getAudioInfo(audioPath)
  } catch (error) {
    console.log('error: ', error)
  }
  loading.value = false
}
async function getAudioInfo(audioPath: string) {
  // TODO 接口获取音频数据

  // const res = await getAudioByResultPath(audioPath)
  // const audioData = res.data
  // const url = URL.createObjectURL(audioData)
  // audioSrc.value = url

  audioSrc.value = getAudioByResultPath(audioPath)
}
onMounted(() => {
  console.log('tts-detail-mounted')
  getContentDetail()
})

return { __sfc: true,props, contentList, taskTitle, audioSrc, loading, getContentDetail, getAudioInfo, AudioTextHighlight }
}

})